import React from 'react';
import keycloak from '../keycloak';
import theme from '../theme';
import { Card, Button, Badge } from '../components/common';

export default function Profile({ profile }) {
  const handleChangePassword = () => {
    // Redirect to Keycloak account management
    const accountUrl = `${keycloak.authServerUrl}/realms/${keycloak.realm}/account/#/security/signingin`;
    window.open(accountUrl, '_blank');
  };

  return (
    <div style={{ maxWidth: '600px' }}>
      <h1 style={{ fontSize: '20px', marginBottom: '20px' }}>Profile & Security</h1>

      <Card style={{ marginBottom: '20px' }}>
        <h3 style={{ margin: '0 0 16px', fontSize: '16px' }}>Account details</h3>
        <div style={row}><span style={label}>Organisation</span><span>{profile?.customerName}</span></div>
        <div style={row}><span style={label}>Username</span><span style={{ fontFamily: theme.fonts.mono }}>{profile?.username}</span></div>
        <div style={row}><span style={label}>Customer ID</span><span style={{ fontFamily: theme.fonts.mono, fontSize: '12px' }}>{profile?.customerId}</span></div>
        <div style={row}>
          <span style={label}>Portal role</span>
          <Badge color="info">{profile?.portalRole}</Badge>
        </div>
      </Card>

      <Card style={{ marginBottom: '20px' }}>
        <h3 style={{ margin: '0 0 16px', fontSize: '16px' }}>Security</h3>
        <p style={{ fontSize: '14px', color: theme.colors.textLight, margin: '0 0 16px' }}>
          Manage your password and two-factor authentication through the Keycloak account portal.
        </p>
        <Button variant="outline" onClick={handleChangePassword}>Manage security settings</Button>
      </Card>

      <Card>
        <h3 style={{ margin: '0 0 16px', fontSize: '16px' }}>Session</h3>
        <p style={{ fontSize: '14px', color: theme.colors.textLight, margin: '0 0 16px' }}>
          Your session will expire automatically after a period of inactivity. You can sign out now to end your session immediately.
        </p>
        <Button variant="danger" onClick={() => keycloak.logout({ redirectUri: window.location.origin })}>
          Sign out
        </Button>
      </Card>
    </div>
  );
}

const row = { display: 'flex', justifyContent: 'space-between', padding: '8px 0', borderBottom: `1px solid ${theme.colors.borderLight}`, fontSize: '14px' };
const label = { color: theme.colors.textLight };
